// 書類の画像を遅延ロードするカスタムフック
import React, { useState, useEffect } from 'react';
import axios from '../axios';
import { ShelfInfo } from '../types/FileUpload';
import { loan_types, status_code_list } from '../Const';

const useLazyLoad = (
  shelf_info_a: ShelfInfo,
  shelf_info_b: ShelfInfo,
  shelf_info_c: ShelfInfo,
  shelf_info_d: ShelfInfo,
  shelf_info_e: ShelfInfo,
  shelf_info_f: ShelfInfo,
  shelf_info_g: ShelfInfo,
  shelf_info_h: ShelfInfo,
  shelf_info_i: ShelfInfo,
  shelf_info_j: ShelfInfo,
  shelf_info_k: ShelfInfo,
  shelf_info_aa: ShelfInfo,
  shelf_info_ab: ShelfInfo,
  shelf_info_ac: ShelfInfo,
  shelf_info_ad: ShelfInfo,
  shelf_info_ae: ShelfInfo,
  shelf_info_af: ShelfInfo,
  shelf_info_ag: ShelfInfo,
  shelf_info_ah: ShelfInfo,
  shelf_info_ai: ShelfInfo,
  shelf_info_aj: ShelfInfo,
  shelf_info_ak: ShelfInfo,
  shelf_info_al: ShelfInfo,
  shelf_info_am: ShelfInfo,
  shelf_info_an: ShelfInfo,
  shelf_info_ao: ShelfInfo,
  shelf_info_ap: ShelfInfo,
  shelf_info_aq: ShelfInfo,
  shelf_info_ar: ShelfInfo,
  shelf_info_as: ShelfInfo,
  shelf_info_at: ShelfInfo,
  shelf_info_au: ShelfInfo,
  shelf_info_av: ShelfInfo,
  shelf_info_aw: ShelfInfo,
  shelf_info_ax: ShelfInfo,
  shelf_info_ay: ShelfInfo,
  shelf_info_az: ShelfInfo,
  shelf_info_ba: ShelfInfo,
  shelf_info_bb: ShelfInfo,
  shelf_info_bc: ShelfInfo,
  shelf_info_bd: ShelfInfo,
  shelf_info_be: ShelfInfo,
  shelf_info_bf: ShelfInfo,
  shelf_info_bg: ShelfInfo,
  shelf_info_bh: ShelfInfo,
  shelf_info_bi: ShelfInfo,
  setShelfInfoA: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoB: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoC: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoD: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoE: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoF: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoG: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoH: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoI: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoJ: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoK: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAA: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAB: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAC: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAD: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAE: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAF: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAG: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAH: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAI: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAJ: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAK: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAL: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAM: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAN: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAO: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAP: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAQ: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAR: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAS: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAT: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAU: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAV: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAW: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAX: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAY: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoAZ: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoBA: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoBB: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoBC: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoBD: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoBE: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoBF: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoBG: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoBH: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  setShelfInfoBI: React.Dispatch<React.SetStateAction<ShelfInfo>>,
  is_loading: boolean,
  status_code: number,
  loan_type?: string,
  on_loan_application_button_clicked?: boolean
) => {
  const [ready_to_load, setReadyToLoad] = useState(false);

  const boundary_status =
    loan_type === loan_types.housing_loan_firmly ||
    loan_type === loan_types.housing_loan_firmly_refinancing
      ? status_code_list.pre_examination1
      : status_code_list.borrowing_application;
  useEffect(() => {
    if (
      !is_loading &&
      ready_to_load &&
      status_code >= boundary_status &&
      !on_loan_application_button_clicked
    ) {
      // しっかり審査の場合はステータス1600以上、それ以外はステータス2100以上
      documentImageLazyLoad();
      setReadyToLoad(false);
    } else {
      setReadyToLoad(true);
    }
  }, [is_loading, status_code, boundary_status]);

  /**
   * 書類の画像の遅延ロードを実行する
   */
  const documentImageLazyLoad = async () => {
    try {
      const reception_id = document.getElementById('reception_id')?.getAttribute('reception_id');
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/file/lazyload`,
        {
          r_id: reception_id,
        }
      );

      // バリデーションエラーが返却された時はエラーメッセージを表示
      if (!response.data.result) {
        const keys = Object.keys(response.data.message);
        alert(response.data.message[keys[0]][0]);
        return;
      }

      // 各提出書類棚のディープコピーを取得する
      // 申込人
      const new_shelf_info_a = { ...shelf_info_a };
      const new_shelf_info_b = { ...shelf_info_b };
      // 有担保
      const new_shelf_info_c = { ...shelf_info_c };
      // 無担保
      const new_shelf_info_d = { ...shelf_info_d };
      // 農業資金、近代化資金
      const new_shelf_info_e = { ...shelf_info_e };
      // 連帯債務者１
      const new_shelf_info_f = { ...shelf_info_f };
      const new_shelf_info_g = { ...shelf_info_g };
      // 連帯債務者２
      const new_shelf_info_h = { ...shelf_info_h };
      const new_shelf_info_i = { ...shelf_info_i };
      // 連帯債務者３
      const new_shelf_info_j = { ...shelf_info_j };
      const new_shelf_info_k = { ...shelf_info_k };
      // 連帯債務者４
      const new_shelf_info_aa = { ...shelf_info_aa };
      const new_shelf_info_ab = { ...shelf_info_ab };
      // 連帯債務者５
      const new_shelf_info_ac = { ...shelf_info_ac };
      const new_shelf_info_ad = { ...shelf_info_ad };
      // 連帯債務者６
      const new_shelf_info_ae = { ...shelf_info_ae };
      const new_shelf_info_af = { ...shelf_info_af };
      // 連帯債務７
      const new_shelf_info_ag = { ...shelf_info_ag };
      const new_shelf_info_ah = { ...shelf_info_ah };
      // 連帯債務８
      const new_shelf_info_ai = { ...shelf_info_ai };
      const new_shelf_info_aj = { ...shelf_info_aj };
      // 連帯債務者９
      const new_shelf_info_ak = { ...shelf_info_ak };
      const new_shelf_info_al = { ...shelf_info_al };
      // 連帯債務者１０
      const new_shelf_info_am = { ...shelf_info_am };
      const new_shelf_info_an = { ...shelf_info_an };
      // 連帯債務者１１
      const new_shelf_info_ao = { ...shelf_info_ao };
      const new_shelf_info_ap = { ...shelf_info_ap };
      // 連帯債務者１２
      const new_shelf_info_aq = { ...shelf_info_aq };
      const new_shelf_info_ar = { ...shelf_info_ar };
      // 連帯債務者１３
      const new_shelf_info_as = { ...shelf_info_as };
      const new_shelf_info_at = { ...shelf_info_at };
      // 連帯債務者１４
      const new_shelf_info_au = { ...shelf_info_au };
      const new_shelf_info_av = { ...shelf_info_av };
      // 連帯債務者１５
      const new_shelf_info_aw = { ...shelf_info_aw };
      const new_shelf_info_ax = { ...shelf_info_ax };
      // 連帯債務者１６
      const new_shelf_info_ay = { ...shelf_info_ay };
      const new_shelf_info_az = { ...shelf_info_az };
      // 連帯債務者１７
      const new_shelf_info_ba = { ...shelf_info_ba };
      const new_shelf_info_bb = { ...shelf_info_bb };
      // 連帯債務者１８
      const new_shelf_info_bc = { ...shelf_info_bc };
      const new_shelf_info_bd = { ...shelf_info_bd };
      // 連帯債務者１９
      const new_shelf_info_be = { ...shelf_info_be };
      const new_shelf_info_bf = { ...shelf_info_bf };
      // 連帯債務者２０
      const new_shelf_info_bg = { ...shelf_info_bg };
      const new_shelf_info_bh = { ...shelf_info_bh };
      // お申込人（経営改善資金計画書）
      const new_shelf_info_bi = { ...shelf_info_bi };

      // file_dataを置き換える
      // お申込人
      new_shelf_info_a.file_data = response.data.detail.A.file_data ?? new_shelf_info_a.file_data;
      new_shelf_info_b.file_data = response.data.detail.B.file_data ?? new_shelf_info_b.file_data;
      // 有担保
      new_shelf_info_c.file_data = response.data.detail.C.file_data ?? new_shelf_info_c.file_data;
      // 無担保
      new_shelf_info_d.file_data = response.data.detail.D.file_data ?? new_shelf_info_d.file_data;
      // 農業資金、近代化資金
      new_shelf_info_e.file_data = response.data.detail.E.file_data ?? new_shelf_info_e.file_data;
      // 連帯債務者１
      new_shelf_info_f.file_data = response.data.detail.F.file_data ?? new_shelf_info_f.file_data;
      new_shelf_info_g.file_data = response.data.detail.G.file_data ?? new_shelf_info_g.file_data;
      // 連帯債務者２
      new_shelf_info_h.file_data = response.data.detail.H.file_data ?? new_shelf_info_h.file_data;
      new_shelf_info_i.file_data = response.data.detail.I.file_data ?? new_shelf_info_i.file_data;
      // 連帯債務者３
      new_shelf_info_j.file_data = response.data.detail.J.file_data ?? new_shelf_info_j.file_data;
      new_shelf_info_k.file_data = response.data.detail.K.file_data ?? new_shelf_info_k.file_data;
      // 連帯債務者４
      new_shelf_info_aa.file_data =
        response.data.detail.AA.file_data ?? new_shelf_info_aa.file_data;
      new_shelf_info_ab.file_data =
        response.data.detail.AB.file_data ?? new_shelf_info_ab.file_data;
      // 連帯債務者５
      new_shelf_info_ac.file_data =
        response.data.detail.AC.file_data ?? new_shelf_info_ac.file_data;
      new_shelf_info_ad.file_data =
        response.data.detail.AD.file_data ?? new_shelf_info_ad.file_data;
      // 連帯債務者６
      new_shelf_info_ae.file_data =
        response.data.detail.AE.file_data ?? new_shelf_info_ae.file_data;
      new_shelf_info_af.file_data =
        response.data.detail.AF.file_data ?? new_shelf_info_af.file_data;
      // 連帯債務者７
      new_shelf_info_ag.file_data =
        response.data.detail.AG.file_data ?? new_shelf_info_ag.file_data;
      new_shelf_info_ah.file_data =
        response.data.detail.AH.file_data ?? new_shelf_info_ah.file_data;
      // 連帯債務者８
      new_shelf_info_ai.file_data =
        response.data.detail.AI.file_data ?? new_shelf_info_ai.file_data;
      new_shelf_info_aj.file_data =
        response.data.detail.AJ.file_data ?? new_shelf_info_aj.file_data;
      // 連帯債務者９
      new_shelf_info_ak.file_data =
        response.data.detail.AK.file_data ?? new_shelf_info_ak.file_data;
      new_shelf_info_al.file_data =
        response.data.detail.AL.file_data ?? new_shelf_info_al.file_data;
      // 連帯債務者１０
      new_shelf_info_am.file_data =
        response.data.detail.AM.file_data ?? new_shelf_info_am.file_data;
      new_shelf_info_an.file_data =
        response.data.detail.AN.file_data ?? new_shelf_info_an.file_data;
      // 連帯債務者１１
      new_shelf_info_ao.file_data =
        response.data.detail.AO.file_data ?? new_shelf_info_ao.file_data;
      new_shelf_info_ap.file_data =
        response.data.detail.AP.file_data ?? new_shelf_info_ap.file_data;
      // 連帯債務者１２
      new_shelf_info_aq.file_data =
        response.data.detail.AQ.file_data ?? new_shelf_info_aq.file_data;
      new_shelf_info_ar.file_data =
        response.data.detail.AR.file_data ?? new_shelf_info_ar.file_data;
      // 連帯債務者１３
      new_shelf_info_as.file_data =
        response.data.detail.AS.file_data ?? new_shelf_info_as.file_data;
      new_shelf_info_at.file_data =
        response.data.detail.AT.file_data ?? new_shelf_info_at.file_data;
      // 連帯債務者１４
      new_shelf_info_au.file_data =
        response.data.detail.AU.file_data ?? new_shelf_info_au.file_data;
      new_shelf_info_av.file_data =
        response.data.detail.AV.file_data ?? new_shelf_info_av.file_data;
      // 連帯債務者１５
      new_shelf_info_aw.file_data =
        response.data.detail.AW.file_data ?? new_shelf_info_aw.file_data;
      new_shelf_info_ax.file_data =
        response.data.detail.AX.file_data ?? new_shelf_info_ax.file_data;
      // 連帯債務者１６
      new_shelf_info_ay.file_data =
        response.data.detail.AY.file_data ?? new_shelf_info_ay.file_data;
      new_shelf_info_az.file_data =
        response.data.detail.AZ.file_data ?? new_shelf_info_az.file_data;
      // 連帯債務者１７
      new_shelf_info_ba.file_data =
        response.data.detail.BA.file_data ?? new_shelf_info_ba.file_data;
      new_shelf_info_bb.file_data =
        response.data.detail.BB.file_data ?? new_shelf_info_bb.file_data;
      // 連帯債務者１８
      new_shelf_info_bc.file_data =
        response.data.detail.BC.file_data ?? new_shelf_info_bc.file_data;
      new_shelf_info_bd.file_data =
        response.data.detail.BD.file_data ?? new_shelf_info_bd.file_data;
      // 連帯債務者１９
      new_shelf_info_be.file_data =
        response.data.detail.BE.file_data ?? new_shelf_info_be.file_data;
      new_shelf_info_bf.file_data =
        response.data.detail.BF.file_data ?? new_shelf_info_bf.file_data;
      // 連帯債務者２０
      new_shelf_info_bg.file_data =
        response.data.detail.BG.file_data ?? new_shelf_info_bg.file_data;
      new_shelf_info_bh.file_data =
        response.data.detail.BH.file_data ?? new_shelf_info_bh.file_data;
      // お申込人（経営改善資金計画書）
      new_shelf_info_bi.file_data =
        response.data.detail.BI.file_data ?? new_shelf_info_bi.file_data;

      // stateを更新する
      // お申込人
      setShelfInfoA(new_shelf_info_a);
      setShelfInfoB(new_shelf_info_b);
      // 有担保
      setShelfInfoC(new_shelf_info_c);
      // 無担保
      setShelfInfoD(new_shelf_info_d);
      // 農業資金、近代化資金
      setShelfInfoE(new_shelf_info_e);
      // 連帯債務者１
      setShelfInfoF(new_shelf_info_f);
      setShelfInfoG(new_shelf_info_g);
      // 連帯債務者２
      setShelfInfoH(new_shelf_info_h);
      setShelfInfoI(new_shelf_info_i);
      // 連帯債務者３
      setShelfInfoJ(new_shelf_info_j);
      setShelfInfoK(new_shelf_info_k);
      // 連帯債務者４
      setShelfInfoAA(new_shelf_info_aa);
      setShelfInfoAB(new_shelf_info_ab);
      // 連帯債務者５
      setShelfInfoAC(new_shelf_info_ac);
      setShelfInfoAD(new_shelf_info_ad);
      // 連帯債務者６
      setShelfInfoAE(new_shelf_info_ae);
      setShelfInfoAF(new_shelf_info_af);
      // 連帯債務者７
      setShelfInfoAG(new_shelf_info_ag);
      setShelfInfoAH(new_shelf_info_ah);
      // 連帯債務者８
      setShelfInfoAI(new_shelf_info_ai);
      setShelfInfoAJ(new_shelf_info_aj);
      // 連帯債務者９
      setShelfInfoAK(new_shelf_info_ak);
      setShelfInfoAL(new_shelf_info_al);
      // 連帯債務者１０
      setShelfInfoAM(new_shelf_info_am);
      setShelfInfoAN(new_shelf_info_an);
      // 連帯債務者１１
      setShelfInfoAO(new_shelf_info_ao);
      setShelfInfoAP(new_shelf_info_ap);
      // 連帯債務者１２
      setShelfInfoAQ(new_shelf_info_aq);
      setShelfInfoAR(new_shelf_info_ar);
      // 連帯債務者１３
      setShelfInfoAS(new_shelf_info_as);
      setShelfInfoAT(new_shelf_info_at);
      // 連帯債務者１４
      setShelfInfoAU(new_shelf_info_au);
      setShelfInfoAV(new_shelf_info_av);
      // 連帯債務者１５
      setShelfInfoAW(new_shelf_info_aw);
      setShelfInfoAX(new_shelf_info_ax);
      // 連帯債務者１６
      setShelfInfoAY(new_shelf_info_ay);
      setShelfInfoAZ(new_shelf_info_az);
      // 連帯債務者１７
      setShelfInfoBA(new_shelf_info_ba);
      setShelfInfoBB(new_shelf_info_bb);
      // 連帯債務者１８
      setShelfInfoBC(new_shelf_info_bc);
      setShelfInfoBD(new_shelf_info_bd);
      // 連帯債務者１９
      setShelfInfoBE(new_shelf_info_be);
      setShelfInfoBF(new_shelf_info_bf);
      // 連帯債務者２０
      setShelfInfoBG(new_shelf_info_bg);
      setShelfInfoBH(new_shelf_info_bh);
      // お申込人（経営改善資金計画書）
      setShelfInfoBI(new_shelf_info_bi);
    } catch (error) {
      alert(error.response.data.message);
    }
  };
};

export default useLazyLoad;
